module.exports = {
  4.3: '1.3rem',
  8.2: '2.2rem',
  140: '140%',
};
